<template>
<div class="contents_855">
  <header-bar active="plan"></header-bar>
  <div v-show="isStep1">
    <h1 class="title2">{{ $t('changePlan') }}</h1>
    <div class="contents_box mg20">
      <table class="form_tab form_line_top">
        <tr>
          <th><p class="item2">{{ $t('plan.plan') }}<span class="font_orange">*</span></p></th>
          <td>
            <template v-if="isRegisteredViaPartnerVenue">
              <span>{{ $t('master.planPart.tx') }}</span>
            </template>
            <template v-else>
              <p>
                <select v-model="planPart1" class="w200" @change="onPlanChange()"
                    :class="{error_outline: this.errors.planPart1}">
                  <option value="">{{ $t('select') }}</option>
                  <option v-for="elem in planParts1" :key="`planPart1-${elem.key}`" v-bind:value="elem.key">
                    {{elem.val}}
                  </option>
                </select>
              </p>
              <p>
                <span class="iferror" v-show="errors.planPart1_required">
                  ▲ {{ $t('required') }}
                </span>
              </p>
              <p>
                <span class="iferror" v-show="errors.planPart1_unchangeable">
                  ▲ {{ $t('plan.cannotChangePlan') }}
                </span>
              </p>
              <p>
                <span class="iferror" v-show="errors.cannotChangeToOnetimePlan">
                  ▲ {{ $t('plan.cannotChangeToOnetimePlan') }}
                </span>
              </p>
              <p>
                <span class="iferror" v-show="errors.notarea">
                  ▲ {{ $t('washRequest.errors.areaUnavailable') }}
                </span>
              </p>
            </template>
          </td>
        </tr>
        <tr>
          <th><p class="item2">{{ $t('plan.pickupMethod') }}<span class="font_orange">*</span></p></th>
          <td>
            <p>
              <select v-model="planPart2" class="w250" @change="onPlanChange()"
                  :class="{error_outline: this.errors.planPart2}">
                <option value="">{{ $t('select') }}</option>
                <option v-for="elem in lovs.pd_type" :key="`pd_type-${elem.key}`" v-bind:value="elem.key">
                  {{elem.val}}
                </option>
              </select>
            </p>
            <p>
              <span class="iferror" v-show="errors.planPart2_required">
                ▲ {{ $t('required') }}
              </span>
            </p>
            <div v-if="showPdSameTime" class="wrap_input">
              <div class="slc">
                <input id="same_time_delivery_radio1" type="radio" value="" v-model="pdSameTime" @change="onPlanChange()">
                <label for="same_time_delivery_radio1" class="ml5">{{ $t('separate') }}</label>
              </div>
              <div class="slc">
                <input id="same_time_delivery_radio2" type="radio" value="1" v-model="pdSameTime" @change="onPlanChange()">
                <label for="same_time_delivery_radio2" class="ml5">{{ $t('sameTime') }}</label>
              </div>
              <div class="notes" @click="showSameTimeDeliveryNoteModal = true">?</div>
            </div>
          </td>
        </tr>
        <tr>
          <th><p class="item2">{{ $t('bagSize') }}<span class="font_orange">*</span></p></th>
          <td>
            <p v-if="showBagSizeSlct">
              <select v-model="bagSize" class="w200" @change="onPlanChange()"
                  :class="{error_outline: this.errors.bagSize}">
                <option value="">{{ $t('select') }}</option>
                <option v-for="elem in sizeDisplay" :key="`size-${elem.key}`" v-bind:value="elem.key">
                  {{elem.display}}
                </option>
              </select>
            </p>
            <p v-else>
              {{SizeForHanding}}
            </p>
            <p>
              <span class="iferror" v-show="errors.bagSize_required">
                ▲ {{ $t('required') }}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <th><p class="item2">{{ $t('plan.charge') }}</p></th>
          <td>
            <p v-if="isOnetime">{{ $t('plan.payPerUse') }}</p>
            <p v-else>{{price | currency('',0)}}{{ $t('washRequestOnetime.form.priceUnit') }}({{unitPrice | currency('',0)}}{{ $t('washRequestOnetime.form.pricePerUnit') }})</p>
          </td>
        </tr>
        <tr v-if="!isOnetime">
          <th><p class="item3">{{ $t('paymentMethod') }}<span class="font_orange">*</span></p></th>
          <td>
            <p>
              <span v-for="elem in availablePaymentMethods" :key="`paymentMethod-${elem.key}`" :value="elem.key">
                <input type="radio" v-bind:id="`option${elem.key}`" :value="elem.key" v-model="payment_method"/>
                <label v-bind:for="`option${elem.key}`">{{elem.val}}{{ $t('profile.paymentSuffix') }}</label>
              </span>
            </p>
            <p>
              <span class="iferror" v-show="errors.payment_method_unselectable">
                ▲ {{ $t('plan.errors.cannotSelectInvoice') }}
              </span>
            </p>
            <p>
              <span class="iferror" v-show="errors.payment_method_onetime">
                ▲ {{ $t('plan.errors.cannotSelectInvoiceOnetime') }}
              </span>
            </p>
            <p>
              <span class="iferror" v-show="errors.payment_method_plans">
                ▲ {{ $t('plan.errors.cannotSelectInvoicePlan') }}
              </span>
            </p>
            <p>
              <span class="iferror" v-show="errors.payment_method_unchangeable">
                ▲ {{ $t('plan.errors.cannotChangeInvoice') }}
              </span>
            </p>
            <p>
              <span class="iferror" v-show="errors.payment_method_rejected">
                ▲ {{ $t('plan.errors.cannotSelectInvoiceRejected') }}
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <th class="form_line_l"></th>
            <td class="form_line_r">
              <edit-plan-notice-messages></edit-plan-notice-messages>
            </td>
        </tr>
      </table>

      <div class="err-msg-area" v-show="hasError">
        <span class="font_orange">
          {{ $t('hasErrors') }}
        </span>
      </div>

      <p class="submit_bx_l">
        <router-link :to="{name: 'plan'}" class="submit1 bg_gray">
          {{ $t('backButton') }}
        </router-link>
      </p>
      <p class="submit_bx_r">
        <button @click="nextStep()" class="submit1 bg_green">
          {{ $t('confirmButton') }}
        </button>
      </p>
    </div>
  </div>

  <div v-show="isStep2">
    <h1 class="title2">{{ $t('changePlan') }}</h1>
    <div class="contents_box mg20">
      <p class="mypage_notes mg30 mg_bt30 font_orange">
        {{ $t('confirmInfo') }}
      </p>
      <table class="form_tab form_line_top">
        <tr>
          <th><p class="item2">{{ $t('plan.plan') }}<span class="font_orange">*</span></p></th>
          <td><p>{{planPart1Disp}}</p>
          </td>
        </tr>
        <tr>
          <th><p class="item2">{{ $t('plan.pickupMethod') }}<span class="font_orange">*</span></p></th>
          <td><p>{{planPart2Disp}}</p>
          </td>
        </tr>
        <tr>
          <th><p class="item2">{{ $t('plan.charge') }}</p></th>
          <td>
            <p v-if="isOnetime">{{ $t('plan.payPerUse') }}</p>
            <p v-else>{{price | currency('',0)}}{{ $t('washRequestOnetime.form.priceUnit') }}({{unitPrice | currency('',0)}}{{ $t('washRequestOnetime.form.pricePerUnit') }})</p>
          </td>
        </tr>
        <tr v-if="!isOnetime">
          <th><p class="item2">{{ $t('paymentMethod') }}</p></th>
          <td><p>{{payment_method_disp}}{{ $t('profile.paymentSuffix') }}</p></td>
        </tr>
      </table>

      <div class="err-msg-area">
        <p><span class="font_orange" v-for="(e, index) in serverErrors" :key="`serverError-${index}`">
          {{e}}
        </span></p>
        <p><span class="font_orange" v-show="isStatusWithdrawn">
          {{ $t('accountWithdrawn') }}
        </span></p>
      </div>

      <p class="submit_bx_l">
        <button @click="prevStep()" class="submit1 bg_gray">
          {{ $t('backButton') }}
        </button>
      </p>
      <p v-if="payment_method == 1 && !isOnetime" class="submit_bx_r">
        <button @click="updatePlan()" class="submit1 bg_green">
          {{ $t('enterCardInfo') }}
        </button>
      </p>
      <p v-else class="submit_bx_r">
        <button @click="updatePlan()" class="submit1 submit2 bg_green">
          OK
        </button>
      </p>

      <form id="payment-form" method="post"
          :action="paymentInfo.url" accept-charset="Shift_JIS">
        <input type="hidden" v-for="elem in paymentInfo.formParams" :key="elem.name"
          :name="elem.name" :value="elem.value">
        <input type="hidden" name="RETURL" :value="paymentInfo.retUrl">
      </form>
    </div>
  </div>

  <SameTimeDeliveryNoteModal
    v-if="showSameTimeDeliveryNoteModal"
    @dismiss="showSameTimeDeliveryNoteModal = false"
  />
</div>
</template>

<script>
import userApi from '@/api/user'
import areaInfoApi from '@/api/areaInfo'
import userMixin from '@/mixin/userMixin'
import { getValidPaymentMethodKeys, isUserCreatedThisMonth } from '@/utils/userUtils'
import SameTimeDeliveryNoteModal from '@/components/lib/SameTimeDeliveryNoteModal.vue'
import {
  stoppedStatus,
  creditCardPayment,
  invoicePayment,
  rejectedStatus,
  lovKeyOnetimePaymentMethodCreditCard,
  PAYMENT_METHOD_INVOICE,
} from '@/consts/lov'
import { findPaymentMethod, findStatusType } from '@/utils/lovUtils'
import {
  PLAN_PART_ONETIME,
  PLAN_PART_TRIAL,
  PLAN_PART_MONTHLY_2,
  PLAN_PART_MONTHLY_4,
  PLAN_PART_MONTHLY_40,
  PLAN_PART_MONTHLY_48,
  PLAN_PART_MONTHLY_56,
  getPlanPart,
  isOnetimePlan,
  isMonthlyPlan,
  isPickupDeliverySameTime,
  calculatePlanId,
} from '@/utils/planUtils'
import { validateArea } from '@/validations/userValidations'

export default {
  name: 'plan-edit',
  components: { SameTimeDeliveryNoteModal },
  data() {
    return {
      currentStep: 1,
      maxStep: 2,
      isStep1: true,
      isStep2: false,

      lovs: {},
      planMap: {},
      lovsMap: {},
      sizeDisplay: {},
      optionMagMap: {},

      source_venue_code: '',

      planPart1: '',
      planPart2: '',
      bagSize: '',
      showBagSizeSlct: true,
      showPdSameTime: false,
      pdSameTime: '',
      pdSameTimeOrg: '',
      option: 0,
      planId: '',
      count: 1,
      price: '',
      unitPrice: '',
      payment_method: 1,
      payment_method_disp: '',
      company_name: '',
      planParts1: [],
      isOnetime: false,
      isOnetimeBefore: false,
      isMonthlyPlanBefore: false,
      paymentMethods: [],
      lastMonthlyPaymentMethod: null,
      isStopped: false,
      isCreditCardPaymentStopped: false,
      isInvoicePaymentRejected: false,
      isUserCreatedThisMonth: false,

      areaInfos: [],
      zipcode: '',

      paymentInfo: {
        url: '',
        formParams: [],
        retUrl: '',
      },
      SizeForHanding: '',

      isStatusWithdrawn: false,
      errors: {},
      serverErrors: [],
      bagSizeOrg: '',

      showSameTimeDeliveryNoteModal: false,
    }
  },
  watch: {
    bagSize: function(newBagSize, oldBagSize) {
      const largePlanParts = [
        PLAN_PART_MONTHLY_40,
        PLAN_PART_MONTHLY_48,
        PLAN_PART_MONTHLY_56,
      ]
      const planParts1 = this.lovs.plan_part.filter(p => {
        // お試しプランは選択不可
        if (p.key === PLAN_PART_TRIAL) {
          return false
        }
        // bagSizeがS,Mの場合は40、48、56個を選択できないようにする
        if ((newBagSize == 1 || newBagSize == 2) && largePlanParts.includes(p.key)) {
          return false
        }
        return true
      })
      this.planParts1 = planParts1

      // 40、48、56個を選択した状態で、bagSizeをS,Mに変更した場合は個数をリセットする
      if ((newBagSize == 1 || newBagSize == 2) && largePlanParts.includes(this.planPart1)) {
        this.planPart1 = ''
      }
    }
  },
  computed: {
    isRegisteredViaPartnerVenue() {
      return !!this.source_venue_code
    },
    planPart1Disp() {
      const plan = this.planMap[this.planId]
      if (!plan) { return '' }
      return plan.name
    },
    planPart2Disp() {
      const pdType = this.lovs.pd_type
      if (!pdType) { return '' }
      let ret = ''
      pdType.forEach(e => {
        if (e.key === this.planPart2) {
          ret = e.val
        }
      })
      return ret
    },
    hasError() {
      return Object.keys(this.errors).length > 0
    },
    availablePaymentMethods() {
      if (this.isOnetime) {
        return this.paymentMethods.filter(method => method.key !== PAYMENT_METHOD_INVOICE)
      }
      return this.paymentMethods
    }
  },
  mixins: [userMixin],
  mounted() {
    window.master.$promise.then(mst => {
      this.lovs = mst.lovs
      this.planMap = mst.planMap
      this.lovsMap = mst.lovsMap
      this.optionMagMap = mst.lovsMap.user_plan_option_mag

      this.sizeDisplay = this.lovs.size.reduce((acc, e) => {
        if(e.key == 1){
          e.display = e.val + "（35L）"
        } else if(e.key == 2){
          e.display = e.val + "（80L）"
        } else if(e.key == 3){
          e.display = e.val + "（140L）"
        } else if(e.key == 4){
          e.display = e.val + "（250L）"
        }
        acc[e.key] = e;

        return acc
      }, {})

      this.$store.dispatch('user/getMe')
        .then(me => {
          this.payment_method = me.latest_payment_method_id
          this.company_name = me.company_name
          this.zipcode = me.send_addr_zipcode
          this.source_venue_code = me.source_venue_code

          if (this.lovs.payment_method) {
            const validPaymentMethodKeys = getValidPaymentMethodKeys(me.is_company)
            this.paymentMethods = this.lovs.payment_method.filter(pm => {
              return validPaymentMethodKeys.includes(pm['key'])
            })
            this.ensureValidPaymentMethod()
          }
          this.isStopped = findStatusType(this.lovs, me.status.toString())?.val === stoppedStatus
          const isCreditCardPayment = findPaymentMethod(this.lovs, me.latest_payment_method_id)?.val === creditCardPayment
          this.isCreditCardPaymentStopped = this.isStopped && isCreditCardPayment
          this.isInvoicePaymentRejected = findStatusType(this.lovs, me.status.toString())?.val === rejectedStatus
          this.isUserCreatedThisMonth = isUserCreatedThisMonth(me)
        })

      userApi.getMyCurrentPlanWithOption().then(({ data }) => {
        this.pdSameTime = isPickupDeliverySameTime(data.plan_id) ? '1' : ''
        this.pdSameTimeOrg = this.pdSameTime
        this.planPart1 = getPlanPart(data.plan_id)
        this.planPart2 = data.pickup_delivery_type
        this.bagSize = this.planMap[data.plan_id].size
        this.bagSizeOrg = this.bagSize
        this.option = data.take_over_option
        this.isOnetimeBefore = isOnetimePlan(data.plan_id)
        this.isMonthlyPlanBefore = isMonthlyPlan(data.plan_id)
        this.onPlanChange()
      })

      if (this.lovs.plan_part) {
        const planParts1 = this.lovs.plan_part.filter(p => {
          // お試しプランは選択不可
          return p.key !== PLAN_PART_TRIAL
        })
        this.planParts1 =  planParts1
      }
    })
    areaInfoApi.index().then(({ data }) => {
      this.areaInfos = data
    })
  },
  methods: {
    nextStep() {
      const pdSameTimeStr = this.$t('notice.plan.pickupMethodChange')
      const bagSizeStr = this.$t('notice.plan.sizeChange')
      const changePlanTypeStr = this.$t('notice.plan.changePlanType')
      const nextStr = this.$t('notice.plan.proceedToConfirm')
      const newLineStr = '\r\n'
      let confirmStr = ''

      //ダイアログ表示
      if (!this.isOnetimeBefore && this.isOnetime) {
        confirmStr = changePlanTypeStr + newLineStr + nextStr
      } else if ((this.pdSameTime !== this.pdSameTimeOrg) && (this.bagSize !== this.bagSizeOrg)) {
        confirmStr = bagSizeStr + newLineStr + pdSameTimeStr + newLineStr + nextStr
      } else if (this.pdSameTime !== this.pdSameTimeOrg) {
        confirmStr = pdSameTimeStr + newLineStr + nextStr
      } else if (this.bagSize !== this.bagSizeOrg) {
        confirmStr = bagSizeStr + newLineStr + nextStr
      }

      if (!this.isOnetimeBefore && confirmStr.length > 0 && !confirm(confirmStr)) {
        return
      }

      if (!this.checkCurrentStep()) { return }
      this.currentStep = Math.min(this.currentStep + 1, this.maxStep)
      this.updateStep()
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 0)
    },
    prevStep() {
      this.currentStep = Math.max(this.currentStep - 1, 1)
      this.updateStep()
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 0)
    },
    updateStep() {
      for (let i = 1; i <= this.maxStep; i++) {
        const flag = i === this.currentStep
        this[`isStep${i}`] = flag
      }
      const paymentMethodLov = this.lovsMap.payment_method[this.payment_method]
      this.payment_method_disp = paymentMethodLov ? paymentMethodLov.val : ''
    },
    checkCurrentStep() {
      return this[`checkStep${this.currentStep}`]()
    },
    checkStep1() {
      this.errors = {}
      let result = true

      if (!this.planPart1) {
        this.errors['planPart1'] = true
        this.errors['planPart1_required'] = true
        result = false
      }
      if (!this.planPart2) {
        this.errors['planPart2'] = true
        this.errors['planPart2_required'] = true
        result = false
      }
      if (!this.bagSize) {
        this.errors['bagSize'] = true
        this.errors['bagSize_required'] = true
        result = false
      }
      if (!validateArea({plan_id: this.planId, zipcode: this.zipcode}, this.areaInfos)) {
        this.errors['notarea'] = true
        result = false
      }
      if (this.isMonthlyPlanBefore && isOnetimePlan(this.planId)) {
        if (this.isStopped) {
          this.errors['planPart1_unchangeable'] = true
          result = false
        }
        if (this.isUserCreatedThisMonth) {
          this.errors['cannotChangeToOnetimePlan'] = true
          result = false
        }
      }

      const invoicePaymentSelected = findPaymentMethod(this.lovs, this.payment_method)?.val === invoicePayment
      if (!this.company_name && invoicePaymentSelected) {
        this.errors['payment_method_unselectable'] = true
        result = false
      }
      if (this.planPart1 === PLAN_PART_ONETIME && invoicePaymentSelected) {
        this.errors['payment_method_onetime'] = true
        result = false
      }
      if ((this.planPart1 === PLAN_PART_MONTHLY_2 || this.planPart1 === PLAN_PART_MONTHLY_4) && this.bagSize === '1' && invoicePaymentSelected) {
        this.errors['payment_method_plans'] = true
        result = false
      }
      if (this.planPart1 === PLAN_PART_MONTHLY_2 && this.bagSize === '2' && invoicePaymentSelected) {
        this.errors['payment_method_plans'] = true
        result = false
      }
      const creditCardPaymentNotSelected = findPaymentMethod(this.lovs, this.payment_method)?.val !== creditCardPayment
      if (this.isCreditCardPaymentStopped && creditCardPaymentNotSelected) {
        this.errors['payment_method_unchangeable'] = true
        result = false
      }
      if (this.isInvoicePaymentRejected && invoicePaymentSelected) {
        this.errors['payment_method_rejected'] = true
        result = false
      }

      return result
    },
    checkStep2() {
      return true
    },
    onPlanChange() {
      const wasOnetime = this.isOnetime
      const isOnetimeSelected = this.planPart1 === PLAN_PART_ONETIME
      this.isOnetime = isOnetimeSelected

      if (isOnetimeSelected) {
        if (!wasOnetime) {
          this.lastMonthlyPaymentMethod = this.payment_method
        }
        this.bagSize = this.lovsMap.size[1].key
        this.SizeForHanding = this.$t('master.planPart.tx') + '（45L）'
        this.showBagSizeSlct = false
        this.planId = calculatePlanId({
          planPart: this.planPart1,
          pickupDeliveryType: this.planPart2,
        })
        this.price = ''
        this.unitPrice = ''
        this.showPdSameTime = false
        this.pdSameTime = ''
        this.ensureValidPaymentMethod()
        return
      }

      if (wasOnetime && this.lastMonthlyPaymentMethod) {
        this.payment_method = this.lastMonthlyPaymentMethod
      }

      this.showBagSizeSlct = true
      if (!this.planPart1 || !this.planPart2 || !this.bagSize || !this.count) {
        if (this.planPart1 && this.planPart2) {
          this.showPdSameTime = true
        }
        this.price = ''
        this.unitPrice = ''
        this.ensureValidPaymentMethod()
        return
      }
      //Sサイズ以外はplanIdにサイズを追記する
      let bagSizeSuffix = ''
      const sizeMap = this.lovsMap.size
      if (this.bagSize != 1) {
        bagSizeSuffix = '_' + sizeMap[this.bagSize].val
      }

      // お試しプランは選択不可のため、お試しプラン契約の場合は初期値を選択
      if (this.planPart1 === PLAN_PART_TRIAL) {
        this.planPart1 = ''
        this.price = ''
        this.unitPrice = ''
        this.showPdSameTime = false
        this.pdSameTime = ''
        this.ensureValidPaymentMethod()
        return
      }
      // 月２個プランは、集配同時プランはない
      if (this.planPart1 === PLAN_PART_MONTHLY_2) {
        this.planId = calculatePlanId({
          planPart: this.planPart1,
          pickupDeliveryType: this.planPart2,
          pickupDeliverySameTime: '',
          bagSizeSuffix,
        })
        this.price = this.planMap[this.planId].price * this.count
        this.setOptionPrice()
        this.unitPrice = this.price / this.planMap[this.planId].wash_count
        this.showPdSameTime = false
        this.pdSameTime = ''
        this.ensureValidPaymentMethod()
        return
      }
      // 配達と次回の集配の集配を同時にする場合、末尾に付与
      this.showPdSameTime = true
      this.planId = calculatePlanId({
        planPart: this.planPart1,
        pickupDeliveryType: this.planPart2,
        pickupDeliverySameTime: this.pdSameTime,
        bagSizeSuffix,
      })
      if (!this.planMap[this.planId]) {
        this.price = ''
        this.unitPrice = ''
        this.ensureValidPaymentMethod()
        return
      }
      this.price = this.planMap[this.planId].price * this.count
      this.setOptionPrice()
      this.unitPrice = this.price / this.planMap[this.planId].wash_count
      this.ensureValidPaymentMethod()
    },
    ensureValidPaymentMethod() {
      const availableKeys = this.availablePaymentMethods.map(method => method.key)
      if (availableKeys.length === 0) {
        this.payment_method = ''
        return
      }
      // 単発プランの場合は、支払い方法でクレジットを選択する
      // クレジットが選択できないことは想定していないが、クレジットが選択できない場合は先頭を選択する
      if (this.isOnetime && availableKeys.includes(lovKeyOnetimePaymentMethodCreditCard)) {
        this.payment_method = lovKeyOnetimePaymentMethodCreditCard
        return
      }
      // 現在の支払い方法が利用不可の場合は、利用可能な支払い方法の先頭を選択する
      if (!availableKeys.includes(this.payment_method)) {
        this.payment_method = availableKeys[0]
      }
    },
    setOptionPrice(){
      if (this.option) this.price = this.price * this.optionMagMap[this.option].val
    },
    async updatePlan() {
      this.isStatusWithdrawn = false
      this.serverErrors = []
      const data = {
        plan_id: this.planId,
        pickup_delivery_type: this.planPart2,
        payment_method: this.payment_method,
        user_plan_option: this.option,
      }
      try {
        const { data: responseData } = await userApi.updateMyPlan(data)
        if (this.payment_method == 1 && this.planPart1 !== PLAN_PART_ONETIME) {
          // クレジット決済(単発以外)
          this.updatePaymentFormValues(responseData.payment)
          setTimeout(() => {
            const form = document.querySelector('#payment-form')
            form.submit()
          }, 0)
        } else {
          // 請求書、単発
          if (responseData.payment) {
            this.updatePaymentFormValues(responseData.payment)
            setTimeout(() => {
              const form = document.querySelector('#payment-form')
              form.submit()
            }, 0)
          } else {
            this.$router.push({
              name: 'plan-edit-complete'
            })
          }
        }
      } catch (e) {
        if (e?.response?.data?.reason === 'status_withdrawn') {
          this.isStatusWithdrawn = true
          this.$store.dispatch('localStorage/set', {
            key: 'serverToken',
            val: null,
          })
          return
        }
        const serverErrors = []
        const errRes = e?.response?.data ?? {}
        if (errRes.reason) {
          serverErrors.push(errRes.reason)
        }
        if (typeof errRes.errors === 'object' && errRes.errors !== null) {
          Object.values(errRes.errors).forEach(errorMessages => {
            if (Array.isArray(errorMessages)) {
              serverErrors.push(...errorMessages)
            }
          })
        }
        this.serverErrors = serverErrors
      }
    },
    updatePaymentFormValues(obj) {
      this.paymentInfo.url = obj.url
      this.paymentInfo.formParams = obj.form_params
      this.paymentInfo.retUrl = `${location.protocol}//${location.host}/${obj.ret_url_path}`
    },
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  filter: alpha(opacity=5);
  -moz-opacity:0.5;
  opacity:0.5;
}
.err-msg-area {
  margin: 30px auto 0;
  text-align: center;
  width: 90%;
}

.wrap_input {
  width: 100%;
  margin: 0 auto 0 auto;
  text-align: left;
  overflow: hidden;
}

.wrap_input .slc {
  float: left;
  margin: 10px 15px 0 0;
}

.wrap_input .notes {
  float: left;
  width: 26px;
  height: 26px;
  margin: 10px 0 0 0;
  background-color: #B7E6F1;
  color: #ffffff;
  text-align: center;
  line-height: 26px;
  border-radius: 13px;
  cursor: pointer;
}

@media screen and (max-width: 640px) {
  .wrap_input .slc {
    float: none;
  }
  .wrap_input .notes {
    float: none;
  }
}

</style>
